import type { CountryKey } from '@/app/core/country/interfaces/country.types';

export type { CountryKey as DestinationCountryKey };

export const PRIVATE_DESTINATION_COUNTRIES: ReadonlyArray<{
  key: CountryKey;
  label: string;
  flagSrc: string;
}> = [
  {
    key: 'colombia',
    label: 'Colombia',
    flagSrc: 'home/navbar/menu/flags/Colombia.svg',
  },
  {
    key: 'panama',
    label: 'Panamá',
    flagSrc: 'home/navbar/menu/flags/Panamá.svg',
  },
];
